export const CARD_TYPES = {
  RECENTLY_MESSAGED: 'recentlymessaged',
  LANDLINE: 'landline',
  INVALID: 'invalid',
  OPTOUT: 'opt-out',
} as const;

export const TIME_FRAME_UNIT = {
  DAY_1: 'DAY_1',
  DAY_3: 'DAY_3',
  WEEK_1: 'WEEK_1',
  CUSTOM_TIME: 'CUSTOM_TIME',
} as const;

export const BROADCAST_SUPPRESSION_TYPE = {
  OFF: 'off',
  ADMIN: 'forced',
  RECRUITER: 'optional',
} as const;
